import * as _ from 'underscore';
import { UIElement } from './uiElement';
import { IUIElementOptions, IComboboxOptions } from '../../../interfaces/options';
import { ID } from '../../../const';
import { Templates, Localization } from '../../../compile';

export class Combobox<T> extends UIElement<T> {
	private data: KnockoutObservableArray<T> | KnockoutComputed<T[]>;
	private labelKey: string;
	private placeholder: string;
	private _optionsAfterRender: (option: HTMLElement, item: T) => void;
	private optionsAfterRender: (option: HTMLElement, item: T) => void;

	constructor(
		id: string,
		label: string,
		value: T | KnockoutObservable<T>,
		data: T[] | KnockoutObservableArray<T> | KnockoutComputed<T[]>,
		options?: IComboboxOptions<T>,
		labelKey: string = ID.Label,
		placeholder: string = Localization.Progress.Select
	) {
		options = $.extend(
			true,
			{},
			<IUIElementOptions>{
				widget: {
					widget: Templates.widgets_combobox
				}
			},
			options || {}
		);
		super(id, label, value, options);

		this.data = ko.isObservable(data)
			? <KnockoutObservableArray<T> | KnockoutComputed<T[]>>data
			: ko.observableArray(<T[]>data);
		this.labelKey = labelKey;
		this.placeholder = placeholder;

		this.data.subscribe(newData => {
			let value = this.value();
			if (value) {
				if (newData.indexOf(value) < 0) {
					this.value(null);
				}
			}
		});

		this._optionsAfterRender = options.optionsAfterRender;

		this.optionsAfterRender = (option: HTMLElement, item: T): void => {
			if (_.isFunction(this._optionsAfterRender)) {
				this._optionsAfterRender(option, item);
			}
		};
	}

	public selectBy(value: any, property: string = ID.ID): T {
		let selectItem: T = _.find(this.data(), dataItem => dataItem[property] == value);
		if (selectItem) {
			if (this.value(selectItem) !== undefined) {
				return selectItem;
			}
		}
		return undefined;
	}
}
